// extracted by mini-css-extract-plugin
export default {"over-view":"review_over-view__ieFA2","header-left":"review_header-left__4mLFV","header-right":"review_header-right__vF0KC","review":"review_review__NwJ48"};